
import DukSection from '@src/components/sections/dukSection/dukSection';
import React, { useState } from 'react';
import { Box, Button, Container, Grid } from 'theme-ui';

const dukWithTabs = ({ data, hideTabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      {data.length > 0 && (
        <>
          {!hideTabs && (
            <Container
              sx={{
                transform: 'translateY(-50%)',
                borderRadius: '10px',
                overflow: 'hidden',
                background: 'white',
                boxShadow: '0px 10px 50px #0000001A',
                marginBottom: '-80px',
              }}
            >
              <Grid gap={0} columns={[2, 2]}>
                {data.map((item, index) => (
                  <Button
                    variant={activeTab === index ? 'tabActive' : 'tabDefault'}
                    key={index}
                    onClick={() => {
                      setActiveTab(index);
                    }}
                    py={3}
                    px={4}
                    sx={{
                      fontSize: 4,
                      padding: [4, null, 5],
                      background: activeTab === index ? 'primaryPale' : 'white',
                      border: 0,
                      cursor: 'pointer',
                      borderRadius: '10px',
                      color: activeTab === index ? 'text' : 'label',
                      transition: '200ms ease-in',
                      '&:hover': {
                        background:
                          activeTab === index ? 'primaryPale' : 'primaryPaleBg',
                        color: 'text',
                      },
                    }}
                  >
                    {item.title}
                  </Button>
                ))}
              </Grid>
            </Container>
          )}

          <Box>
            {data.map((item, index) => {
              if (activeTab === index) {
                return (
                  <DukSection
                    key={index}
                    countToShow={1000}
                    questions={item.questions}
                  />
                );
              }
            })}
          </Box>
        </>
      )}
    </>
  );
};

export default dukWithTabs;
